"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "width", "height", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? size : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? size : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#808080' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M1.14467 9.8L3.9 16H5.53733C5.84282 15.9998 6.14342 15.9234 6.41187 15.7776C6.68032 15.6318 6.90812 15.4213 7.07459 15.1651C7.24107 14.909 7.34095 14.6154 7.36518 14.3108C7.38941 14.0063 7.33721 13.7006 7.21333 13.4213L5.69267 10H7.33333C8.21706 10.0011 9.06429 10.3526 9.68919 10.9775C10.3141 11.6024 10.6656 12.4496 10.6667 13.3333H12V0H10.6667C10.6656 0.88373 10.3141 1.73096 9.68919 2.35585C9.06429 2.98075 8.21706 3.33227 7.33333 3.33333H2C1.46957 3.33333 0.960859 3.54405 0.585786 3.91912C0.210714 4.29419 0 4.8029 0 5.33333L0 8C0.00148733 8.37747 0.109768 8.74682 0.312327 9.06534C0.514886 9.38387 0.803451 9.63857 1.14467 9.8ZM5.99467 13.962C6.02868 14.0382 6.0431 14.1218 6.03659 14.205C6.03008 14.2882 6.00287 14.3685 5.95742 14.4386C5.91197 14.5086 5.84972 14.5661 5.77636 14.606C5.70299 14.6458 5.62082 14.6667 5.53733 14.6667H4.76667L2.69267 10H4.23333L5.99467 13.962ZM1.33333 5.33333C1.33333 5.15652 1.40357 4.98695 1.5286 4.86193C1.65362 4.7369 1.82319 4.66667 2 4.66667H7.33333C7.95481 4.66681 8.57 4.54234 9.14254 4.30062C9.71508 4.05889 10.2333 3.70482 10.6667 3.25933V10.074C10.2333 9.62852 9.71508 9.27444 9.14254 9.03272C8.57 8.79099 7.95481 8.66652 7.33333 8.66667H2C1.82319 8.66667 1.65362 8.59643 1.5286 8.47141C1.40357 8.34638 1.33333 8.17681 1.33333 8V5.33333ZM14.862 10.4713L13.3367 8.946L14.2793 8.00333L15.8047 9.52867L14.862 10.4713ZM14.3047 5.30467L13.362 4.362L14.862 2.862L15.8047 3.80467L14.3047 5.30467ZM14 6H16V7.33333H14V6Z",
    fill: fill
  }));
};

exports["default"] = _default;